import { PersonaConfig } from '../types';

export const photographyPersona: PersonaConfig = {
  id: 'photography',
  name: 'Photography',
  icon: '📷',
  description: 'Golden/blue hour tracking, cloud alignment, and astronomical perspective.',
  accentColor: '#f97316',
  timeline: {
    showSolarLunarTrack: true,
    showMoonPhaseBadges: true,
  },
  forecastPanel: {
    temperaturePlotMode: 'single_location_only',
    hideAstronomicalEvents: false,
    showMilkyWayArButton: true,
  },
  mapDefaults: {
    recommendedPrimaryLayer: undefined,
    enabledOverlays: [],
  },
};
